import { useEffect } from 'react';

import { buildBadgedFaviconDataUrl, ensureFaviconLink } from './faviconBadge';
import { FAVICON_PATH } from '../../utils/constants/suggestionTabAlerts';

export function useFaviconBadge(isActive: boolean): void {
  useEffect(() => {
    const link = ensureFaviconLink();
    let cancelled = false;
    if (isActive) {
      buildBadgedFaviconDataUrl().then((dataUrl) => {
        if (!cancelled && dataUrl) link.href = dataUrl;
      });
    } else {
      link.href = FAVICON_PATH;
    }
    return () => {
      cancelled = true;
      link.href = FAVICON_PATH;
    };
  }, [isActive]);
}
